import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';

export const EmptyBagWrapper = styled(Flex)`
  height: 100%;
  width: '100%';
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: scroll;
`;

export const BagAndTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: '100%';
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const BagImageWrapper = styled(Box)`
  position: relative;
  height: 97px;
  width: 73px;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.md.up} {
      height: 118px;
      width: 88px;
    }
  `}
`;

export const YourShoppingBagIsEmpty = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.h4};
    color: ${theme.colors.secondary};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const FreeShippingAndReturns = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const ContinueShoppingButton = styled(LegacyButton)`
  width: 100%;
  text-decoration: none;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;
